import {
  BankApplicationAccountType,
  BankApplicationAdvisor,
  BankApplicationStatus,
  BankApplicationThirdPartyProcessorStatus,
  SubmissionType,
} from '@/types/bankApplications';

type GetBankAccountApplicationTitleProps = {
  fullName: string;
  email: string;
  businessName?: string;
};

export function getBankAccountApplicationTitle({
  fullName,
  email,
  businessName,
}: GetBankAccountApplicationTitleProps) {
  if (!fullName && !businessName) {
    return 'N/A';
  }

  if (!businessName) {
    return `${fullName} - ${email}`;
  }

  return `${businessName}: ${fullName} - ${email}`;
}

export function getBankApplicationAccountTypeLabel(
  accountType: BankApplicationAccountType,
) {
  switch (accountType) {
    case 0:
      return 'Individual';
    case 1:
      return 'Joint';
    case 2:
      return 'Business';
    default:
      return 'Unknown';
  }
}

export function getBankApplicationAccountStatusLabel(
  status: BankApplicationStatus,
) {
  switch (status) {
    case BankApplicationStatus.COMPLETED:
      return 'Completed';
    case BankApplicationStatus.AWAITING_E_SIGN:
      return 'Awaiting E-Sign';
    case BankApplicationStatus.DECLINED:
      return 'Declined';
    case BankApplicationStatus.DRAFT:
      return 'Draft';
    case BankApplicationStatus.NEED_REVIEW:
      return 'Under Review';
    case BankApplicationStatus.SUBMITTED:
    case BankApplicationStatus.SUBMITTED_BY_STAFF:
    case BankApplicationStatus.SUBMITTED_BY_TEAMMATE:
      return 'Submitted';
    default:
      return 'Unknown';
  }
}

export function getBankApplicationSubmissionTypeLabel(
  submissionType: SubmissionType,
) {
  switch (submissionType) {
    case SubmissionType.CUSTOMER_PORTAL:
      return 'Customer Portal';
    case SubmissionType.STAFF_PORTAL:
      return 'Staff Portal';
    default:
      return '';
  }
}

export function getBankApplicationAdvisorText(advisor: BankApplicationAdvisor) {
  if (advisor?.firstName && advisor?.lastName) {
    return `${advisor.firstName} ${advisor.lastName}`;
  }
  return 'N/A';
}

export function getThirdPartyProcessorStatusString(
  thirdPartyProcessorStatus: BankApplicationThirdPartyProcessorStatus,
) {
  switch (thirdPartyProcessorStatus) {
    case BankApplicationThirdPartyProcessorStatus.APPROVED:
      return 'Approved';
    case BankApplicationThirdPartyProcessorStatus.MANUAL_REVIEW:
      return 'Manual Review';
    case BankApplicationThirdPartyProcessorStatus.REJECTED:
      return 'Rejected';
    case BankApplicationThirdPartyProcessorStatus.SUBMITTED:
      return 'Submitted';
    default:
      return 'Unsubmitted';
  }
}
